import { SearchCriteriaType } from '../../types/SearchCriteriaType'
import { useAnalytics } from '@praxis/analytics/client'

export const useEventTracking = () => {
  const { sendEvent, sendClickEvent } = useAnalytics()

  const captureSearchEvent = (searchCriteria: SearchCriteriaType) => {
    if (searchCriteria.dept_class && searchCriteria.dept_class?.length > 0) {
      sendEvent({ event: { type: 'SEARCH', value: searchCriteria.dept_class } })
    }
    if (searchCriteria.dpcis && searchCriteria.dpcis?.length > 0) {
      sendEvent({
        event: { type: 'SEARCH', value: searchCriteria.dpcis.join() },
      })
    }
    if (searchCriteria.tcins && searchCriteria.tcins?.length > 0) {
      sendEvent({
        event: { type: 'SEARCH', value: searchCriteria.tcins.join() },
      })
    }
    if (
      searchCriteria.gms_vendor_numbers &&
      searchCriteria.gms_vendor_numbers?.length > 0
    ) {
      sendEvent({
        event: {
          type: 'SEARCH',
          value: searchCriteria.gms_vendor_numbers.join(),
        },
      })
    }
    if (searchCriteria.factory_id) {
      sendEvent({ event: { type: 'SEARCH', value: searchCriteria.factory_id } })
    }
  }

  const captureSearchResultsExportEvent = (rowCount: number) => {
    sendClickEvent('CLICK', {
      event: { value: `Search Results Export: ${rowCount}` },
    })
  }

  const captureChangeRequestExportEvent = () => {
    sendClickEvent('CLICK', { event: { value: 'Change Request Export' } })
  }

  const captureButtonClickEvent = (buttonName: string, label: string = '') => {
    sendClickEvent('CLICK', {
      event: { value: buttonName + (label ? ' - ' + label : '') },
    })
  }

  return {
    captureSearchEvent,
    captureSearchResultsExportEvent,
    captureChangeRequestExportEvent,
    captureButtonClickEvent,
  }
}
